import { render, staticRenderFns } from "./ComplaintTypeList.vue?vue&type=template&id=35a4d120&scoped=true"
import script from "./ComplaintTypeList.vue?vue&type=script&lang=js"
export * from "./ComplaintTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4d120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a4d120')) {
      api.createRecord('35a4d120', component.options)
    } else {
      api.reload('35a4d120', component.options)
    }
    module.hot.accept("./ComplaintTypeList.vue?vue&type=template&id=35a4d120&scoped=true", function () {
      api.rerender('35a4d120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/circle/complaint/ComplaintTypeList.vue"
export default component.exports